import React from 'react';
import { BiSolidTimer } from 'react-icons/bi';
import { ClockRewind } from 'src/app/app/icons/ClockRewind';

interface AccountBadgeProps {
    accountType: string;
    isInactive?: boolean;
    onInctiveBadgeClick?: () => void;
}

const AccountBadge: React.FC<AccountBadgeProps> = ({ accountType, isInactive, onInctiveBadgeClick }) => {
    if (isInactive) {
        return (
            <span className="border mt-2.5 inline-flex items-center rounded-lg border-1 border-amber-400 hover:border-amber-300 saturate-[1.3] bg-amber-400 hover:bg-amber-300 transition-colors ease-in-out duration-300 px-3 py-1 text-xs font-semibold tracking-normal text-black"
                onClick={(e) => {
                    e.preventDefault();
                    if (onInctiveBadgeClick)
                        onInctiveBadgeClick();
                }}>
                <BiSolidTimer className="w-3.5 h-3.5 mr-1" />
                Activate your account
            </span>
        )
    }

    switch (accountType) {
        case 'archived':
            return (
                <span className="border mt-2.5 inline-flex items-center rounded-lg border-1 border-gray-300 bg-gray-100 px-3 py-1 text-xs font-semibold tracking-normal text-gray-800">
                    Archived
                </span>
            );
        case 'trial':
            return (
                <div className="px-3 py-1.5 bg-yellow-100 rounded-full justify-center items-center flex">
                    <ClockRewind className="w-4 h-4 mr-1.5" color="var(--color-yellow-900)" />
                    <div className="text-[13px] font-medium leading-none text-center text-yellow-900">Trial Plan</div>
                </div>
            );
        case 'basic':
            return (
                <div className="flex items-center justify-center px-3 py-2 rounded-full" style={{ background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.16) 0%, rgba(255, 255, 255, 0) 100%), linear-gradient(135deg, #7549F4 2.88%, #FCA6E9 100%)' }}>
                    <div className="text-[13px] text-shadow font-semibold leading-none text-center text-white">Starter Plan</div>
                </div>
            );
        case 'pro':
            return (
                <div className="flex items-center justify-center px-3 py-2 rounded-full" style={{ background: 'linear-gradient(74.41deg, #F55278 -52.09%, #FCF5C5 170.9%)' }}>
                    <div className="text-[13px] text-shadow font-semibold leading-none text-center text-white">Premium Plan</div>
                </div>
            );
        case 'turbo':
            return (
                <div className="flex items-center justify-center px-3 py-2 rounded-full" style={{ background: 'linear-gradient(225.4deg, #FFCBA0 0%, #DE5A8A 48.11%, #DD5789 48.12%, #9B5BE6 93.59%), radial-gradient(51.8% 49.8% at 36.25% 96.55%, #FFD600 0%, #FF6930 48.44%, #FE3B36 73.44%, rgba(254, 59, 54, 0) 100%)' }}>
                    <div className="text-[13px] text-shadow font-semibold leading-none text-center text-white">Ultra Plan</div>
                </div>
            );
        default:
            return null;
    }
};

export default AccountBadge;
